module.exports = __webpack_public_path__ + "media/images/v3/b_2-f04c940c24258a558ce70590a90d8164.png";